import { render, staticRenderFns } from "./upload-marketplace-item-logo.vue?vue&type=template&id=021f1e22&"
import script from "./upload-marketplace-item-logo.vue?vue&type=script&lang=js&"
export * from "./upload-marketplace-item-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports